import type React from "react";
import { Box, List } from "@mui/material";
import { SidebarItem } from "./SidebarItem";
import { SidebarMenuItem } from "./types/sidebar";

interface SidebarMenuProps {
  items: SidebarMenuItem[];
  theme: any;
  onPermissionCheck: (permission?: string) => boolean;
}

export const SidebarMenu: React.FC<SidebarMenuProps> = ({
  items,
  theme,
  onPermissionCheck,
}) => {
  return (
    <Box sx={{ px: 1, mb: 2, flex: "0 0 auto" }}>
      <List disablePadding>
        {items.map((item) => (
          <SidebarItem
            key={item.title}
            item={item}
            level={0}
            theme={theme}
            onPermissionCheck={onPermissionCheck}
          />
        ))}
      </List>
    </Box>
  );
};
